import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Project } from 'src/app/core/interfaces/production/project';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-production-scheduling-counts-list',
  templateUrl: './production-scheduling-counts-list.component.html',
  styleUrls: ['./production-scheduling-counts-list.component.scss'],
})
export class ProductionSchedulingCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [];

  unscheduledDisplayedColumns: string[] = [
    'projectId',
    'projectShortName',
    'productionSchedulingNotes',
    'customerName',
    'jobaddress',
    'contractDate',
    'projectTotal',
  ];

  scheduledDisplayedColumns: string[] = [
    'projectId',
    'projectShortName',
    'productionSchedulingNotes',
    'foreman',
    'scheduledDate',
    'customerName',
    'jobaddress',
    'contractDate',
    'projectTotal',
    'confirmedDate',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  projectArray: Project[] = [];
  dataSource: MatTableDataSource<Project>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getProjects(this.status);
    });
  }

  getProjects(status: string) {
    this.dataSource = new MatTableDataSource();
    this.isLoading = true;

    if (status) {
      switch (status) {
        case 'needsScheduled':
          this.statusNumber = 0;
          this.statusMessage = 'Projects to Schedule';
          this.displayedColumns = this.unscheduledDisplayedColumns;
          break;
        case 'scheduled':
          this.statusNumber = 1;
          this.statusMessage = 'Projects Scheduled';
          this.displayedColumns = this.scheduledDisplayedColumns;
          break;
        case 'incompleteProject':
          this.statusNumber = 6;
          this.statusMessage = 'Incomplete Projects';
          this.displayedColumns = this.unscheduledDisplayedColumns;
          break;
        case 'timeExtensionRequired':
          this.statusNumber = 7;
          this.statusMessage = 'Projects Requiring Time Extension';
          this.displayedColumns = this.scheduledDisplayedColumns;
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService
        .getProductionSchedulingByStatus(this.statusNumber)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.projectArray = response;
            this.dataSource = new MatTableDataSource(this.projectArray);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          },
          error: (e) => {
            this.isLoading = false;
            console.error(e);
          },
        });
    }
  }

  goToProject(row: Project) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        projectId: row.projectId,
      },
    });
  }

  filterProjects(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
